// filepath: /Users/carlosmartinez/Desktop/url_shortener/front/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './Login';
import Product from './Product';
import EditURL from './EditURL';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/product" element={<Product />} />
          <Route path="/edit-url" element={<EditURL />} />
        </Routes>
    </Router>
  </React.StrictMode>
);